import React from 'react';

function Measure({ measureCount, time, columnEndTime, scale, laneWidth, contentOffsetX }: any) {
    const y = (columnEndTime - time) * scale;
    const chartWidth = 5 * laneWidth; // Assuming 4 lanes
    
    return (
        <g className="measure" transform={`translate(0, ${y})`}>
            <line 
                x1={contentOffsetX} 
                y1="0" 
                x2={contentOffsetX + chartWidth} 
                y2="0" 
                stroke="#9ca3af" 
                strokeWidth="1" 
            />
            <text 
                x={contentOffsetX + chartWidth - 2} 
                y={-2} 
                textAnchor="end" 
                fill="#6b7280" 
                fontSize="8px" 
                fontFamily="monospace" 
                fontWeight="bold"
            >
                {measureCount}
                <tspan fontSize="7px" fontWeight="normal" fill="#9ca3af"> {time.toFixed(1)}s</tspan>
            </text>
        </g>
    );
}

export default Measure;